import { clearAuthSession, isTokenExpired } from "../auth/auth";

const server = import.meta.env.VITE_API_SERVER || "";

export const ApiError = class extends Error {
    constructor(message, status, data = null) {
        super(message);

        this.name = "ApiError";
        this.status = status;
        this.data = data;
    }
};

const redirectToLogin = () => {
    const redirectPath =
        window.location.pathname +
        window.location.search +
        window.location.hash;

    console.log("API redirect to login");
    console.log("Current path:", redirectPath);

    clearAuthSession();

    if (window.location.pathname !== "/login") {
        window.location.replace(
            `/login?redirect=${encodeURIComponent(redirectPath)}`
        );
    }
};


/**
 * 
    apiRequest()
    → authenticated?

    yes
    → token exists?
        no → clear session → /login

    → token locally expired?
        yes → clear session → /login

    → send Authorization: Bearer <token>

    → Java verifies token

    → Java returns 401?
        yes → clear session → /login

    → otherwise return response
 *
 */
export const apiRequest = async (
    endpoint,
    {
        authenticated = true,
        method = "GET",
        headers = {},
        body = undefined,
    } = {}
) => {
    const requestHeaders = new Headers(headers);
    requestHeaders.set("Accept", "application/json");

    if (body !== undefined && !(body instanceof FormData)) {
        requestHeaders.set("Content-Type", "application/json");
    }

    if (authenticated) {
        const token = sessionStorage.getItem("token");

        if (!token) {
            redirectToLogin();
            throw new ApiError("Authentication required", 401);
        }

        if (isTokenExpired(token)) {
            redirectToLogin();
            throw new ApiError("Login required", 401);
        }

        requestHeaders.set("Authorization", `Bearer ${token}`);
    }

    let response;
    try {
        response = await fetch(`${server}${endpoint}`, {
            method,
            headers: requestHeaders,
            body:
                body === undefined ? undefined
                    : body instanceof FormData ? body
                        : JSON.stringify(body)
        });
    } catch (error) {
        throw new ApiError("Unable to connect to server", 0, error);
    }

    const contentType = response.headers.get("content-type") || "";

    let responseData = null;

    if (response.status !== 204) { //204: http status NO Content
        if (contentType.includes("application/json")) {
            responseData = await response.json();
        } else {
            responseData = await response.text();
        }
    }

    if (authenticated && response.status === 401) {
        //for authenticated user if error response of 401
        redirectToLogin();
        throw new ApiError("Session expired", 401, responseData);
    }

    if (!response.ok) {
        const message = responseData?.error ||
            responseData?.message ||
            (typeof responseData === "string" && responseData) ||
            `Request failed (${response.status})`;

        throw new ApiError(message, response.status, responseData);
    }

    return responseData;
}